import React, { Component } from 'react';
import {observer,inject} from 'mobx-react';

import {GoogleApiWrapper, Map, Marker } from 'google-maps-react';

@inject("summaryDataStore")
@observer
class MapProject extends Component {
    /// "https://maps.googleapis.com/maps/api/js?key=AIzaSyAzuLNc4VEXKalcJaG1S8IZe3uCLuZbKhg&callback=initMap"
    render() {
        const { project } = this.props.summaryDataStore;
        return (
            <div className='mapProject'>
                <Map google={this.props.google}
                     style={{width:'100%',height:120, position: 'relative'}}
                     initialCenter={{ lat: project.lat, lng: project.lng }}
                     zoom={17}
                     className="map">
                    <Marker
                        position={{ lat: project.lat, lng: project.lng }}
                    />
                </Map>
            </div>
        );
    }
}

export default GoogleApiWrapper({
    apiKey: "AIzaSyAzuLNc4VEXKalcJaG1S8IZe3uCLuZbKhg"
})(MapProject);


// WEBPACK FOOTER //
// ./src/components/header/mapProject.js